import * as React from "react";
import type { SVGProps } from "react";
const SvgFolderX01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.4 15.6 12 13.2m0 0-2.4-2.4m2.4 2.4-2.4 2.4m2.4-2.4 2.4-2.4m-12 6.741.001-9.124V5.258a1.2 1.2 0 0 1 1.2-1.2h5.718l2.765 2.954H20.4a1.2 1.2 0 0 1 1.2 1.2v9.33a2.4 2.4 0 0 1-2.4 2.399H4.8a2.4 2.4 0 0 1-2.4-2.4"
    />
  </svg>
);
export default SvgFolderX01;
